import {
  call,
  ForkEffect,
  put,
  putResolve,
  takeLeading,
} from "redux-saga/effects";
import { logoutNew } from "../../redux/auth/actions";
import { organizationServiceStatusChange } from "../../redux/healthCheck/actions";
import { hidePreloader, showPreloader } from "../../redux/preloader/actions";
import {
  changeUserLanguageFailure,
  changeUserLanguageSuccses,
  changeUserNotificationFailure,
  changeUserNotificationSuccses,
  userProfileFailure,
  userProfileSuccess,
} from "../../redux/userProfile/actions";
import {
  IChangeLanguage,
  IChangeNotification,
  IUserProfileRequestAction,
  USER_PROFILE,
} from "../../redux/userProfile/types";
import { RoleType } from "../../redux/users";
import { AxiosCustom } from "../../service/Axios";
import { sendToApi } from "../../utils/Languages";

export function* usersProfileWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(USER_PROFILE.REQUEST, getUsersProfileSaga);
}
function* getUsersProfileSaga(action: IUserProfileRequestAction) {
  try {
    console.log("getProfile");
    const result = yield call(() => AxiosCustom.getUsersProfile());

    if (result?.data?.roleName && result?.data?.roleName === RoleType.DEV) {
      console.log("devRole");
      yield put(logoutNew());
    } else yield putResolve(userProfileSuccess(result.data));
    yield put(organizationServiceStatusChange(true));
    return;
  } catch (error) {
    console.log("error profile" + error);
    if (error?.response?.status === 503)
      yield put(organizationServiceStatusChange(false));
    yield put(userProfileFailure(error));
    if (
      error?.response?.status === 404 ||
      error?.response?.status === 401 ||
      error?.response?.status === 406
      // ||
      // error?.response?.status === 500 ||
      // error?.response?.status === 501
    ) {
      yield put(logoutNew());
    } else {
      // if (action?.payload?.withErrorMessage) yield call(ErrorMonitor, e, ErrorMessages.USERS_PROFILE);
    }
  }
}

export function* changeUserLanguageWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(USER_PROFILE.CHANGE_LANGUAGE, changeUserLanguageSaga);
}
function* changeUserLanguageSaga(action: IChangeLanguage) {
  try {
    if (action.payload.withPreload) yield put(showPreloader());
    yield call(() =>
      AxiosCustom.changeLanguage({
        language: sendToApi(action.payload.language),
      })
    );
    yield put(changeUserLanguageSuccses(action.payload.language));
    // yield put(snackBarSuccess(Messages.LANG_EDIT));
    yield put(hidePreloader());
  } catch (error) {
    yield put(hidePreloader());
    yield put(changeUserLanguageFailure(error));
    // yield call(ErrorMonitor, e, ErrorMessages.LANG_EDIT);
  }
}

export function* changeUserNotificationWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    USER_PROFILE.CHANGE_NOTIFICATION,
    changeUserNotificationSaga
  );
}
function* changeUserNotificationSaga(action: IChangeNotification) {
  try {
    yield call(() =>
      AxiosCustom.userNotification(action.payload.userId, action.payload.value)
    );

    yield put(changeUserNotificationSuccses(action.payload.value));
    // yield put(snackBarSuccess(Messages.EDIT_NOTIFICATION_SUCCESS));
  } catch (error) {
    yield put(changeUserNotificationFailure(error));
    // yield call(ErrorMonitor, e, ErrorMessages.CHANGE_NOTIFICATION);
  }
}
